/* unplugin-vue-components disabled */import { render } from "./FixedInfo.vue?vue&type=template&id=7ec88264&scoped=true&ts=true"
import script from "./FixedInfo.vue?vue&type=script&lang=ts"
export * from "./FixedInfo.vue?vue&type=script&lang=ts"

import "./FixedInfo.vue?vue&type=style&index=0&id=7ec88264&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec88264"]])

export default __exports__